<template>
  <div class="izdelek">
    <div class="tagPlaceHolder">
      <slot name="tag">
        <div class="tag" v-if="tag !== null">{{tag}}</div>
      </slot>
    </div>
    <div class="iconPlaceholder">
      <slot name="icon"></slot>
    </div>
    <div class="titlePlaceholder">
      <slot name="title">{{title}}</slot>
    </div>
    <div class="subtitlePlaceholder">
      <slot name="subtitle">{{subtitle}}</slot>
    </div>
    <div class="line">
      <hr>
    </div>
    <div class="content">
      <slot></slot>
    </div>
    <div class="izdelekFooter">
      <slot name="footer">bla bla bla</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Izdelek',
  props: {
    tag: {
      type: String,
      default: null
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Izdelki/Izdelek.vue